export default "__VITE_ASSET__76065140__"